import axiosClient from './axiosClient';

const priceWatchApi = {
    // Danh sách sản phẩm đang theo dõi
    getMyWatches: () => axiosClient.get('price-watch'),

    // Thêm sản phẩm vào watchlist
    addWatch: ({ itemId, platform, productName, imageUrl, productLink, currentPrice, alertThreshold, alertTargetPrice }) =>
        axiosClient.post('price-watch', { itemId, platform, productName, imageUrl, productLink, currentPrice, alertThreshold, alertTargetPrice }),

    // Cập nhật ngưỡng alert
    updateWatchAlert: (id, { alertThreshold, alertTargetPrice }) =>
        axiosClient.patch(`price-watch/${id}/alert`, { alertThreshold, alertTargetPrice }),

    // Xóa khỏi watchlist
    removeWatch: (id) => axiosClient.delete(`price-watch/${id}`),

    // Kiểm tra sản phẩm có đang được theo dõi chưa
    checkWatch: (itemId, platform = 'shopee') =>
        axiosClient.get(`price-watch/check/${itemId}`, { params: { platform } }),
};

export default priceWatchApi;
